import { Account } from './types';

export function extractJwtPayload(jwt: string): Account & {
  exp: number;
} {
  const payload = window.atob(jwt.split('.')[1]);
  return JSON.parse(payload);
}